import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
/**
 * tailwind-merge only knows Tailwind's stock scales. This design system adds
 * semantic radius/shadow roles and a `2xs` type step (docs/010-theming-and-tokens.md),
 * so without this extension `cn('rounded-full', 'rounded-card')` would keep BOTH
 * classes instead of last-wins.
 */
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            rounded: [{ rounded: ["control", "card"] }],
            shadow: [{ shadow: ["input", "popover", "overlay", "card", "focus"] }],
            "font-size": [{ text: ["2xs"] }],
        },
    },
});
/**
 * Merge Tailwind class names, last-wins on conflicts.
 *
 * The only sanctioned way to build a `className`. Template-string concatenation
 * in `className` is banned (docs/009-ui-design-guidelines.md).
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map